import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Form,
  Input,
  Row,
  Table,
  Col,
  Progress,
} from 'reactstrap';
import { useForm } from 'react-hook-form';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import NotificationAlert from 'react-notification-alert';

import { db } from '../../MY_LOGIN_AND_SIGNUP/db/config';

function AddMaterial({ handleClose, notifi, currentBatchId, currentUser, batchData }) {
  const notification = useRef();


  const { handleSubmit, register, errors, reset } = useForm();
  const [bookData, setBookData] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState();
  const [quizData, setQuizData] = useState([]);
  const [selectedBook, setSelectedBook] = useState({});
  const [selectedQuiz, setSelectedQuiz] = useState({});
  const [selectedQuizTestArr, setSelectedQuizTestArr] = useState([]);
  const [currentBatch, setCurrentBatch] = useState();
  
  const [selectedQuizCount, setSelectedQuizCount] = useState([]);
  const [selectedBookCount, setSelectedBookCount] = useState([]);
  const [progressVisible, setProgressVisible] = useState(true);
  const [progressValue, setProgressValue] = useState(8);

  const [addedBooks, setAddedBooks] = useState({});
  const [addedQuizes, setAddedQuizes] = useState({});

  const notify = (msg, err) => {
    let color = err === true ? 'danger' : 'success';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err === true ? 'Error' : 'Success'}</b> -{msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notifi.current) {
      notification.current.notificationAlert(options);
    }
  };
  let bookCount = Object.entries(selectedBook).map(([k, v], i) => {
    return { id: k, value: v };
  });
  let quizCount = Object.entries(selectedQuiz).map(([k, v], i) => {
    return { id: k, value: v };
  });

  let bookAddedCount = Object.entries(addedBooks)?.map(([k, v], i) => {
    return { id: k, value: v };
  });

  let quizAddedCount = Object.entries(addedQuizes)?.map(([k, v], i) => {
    return { id: k, value: v };
  });

  useEffect(() => {
    bookCount = bookCount.filter((item) => item.value === true);
    setSelectedBookCount(bookCount);
  }, [selectedBook]);

  useEffect(() => {
    quizCount = quizCount.filter((item) => item.value === true);
    setSelectedQuizCount(quizCount);
  }, [selectedQuiz]);

  const getQuizTest = () => {
    try {
      db.collection('QuizTest')
        .where('status', '==', 0)
        .orderBy('createdAt', 'desc')
        .get()
        .then((querySnapshot) => {
          const data = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
            select: false, // Add select flag for UI interactions
          }));

          setQuizData(data);
        })
        .catch((err) => {
          console.error("Error fetching quizzes:", err);
        });
        
      db.collection('AssignedQuizTests')
        .where('batchIds', 'array-contains', currentBatchId)
        .get()
        .then((querySnapshot) => {
          const data = querySnapshot.docs.map((doc) => doc.data().QuizTestId);
          setSelectedQuizTestArr(data);
        })
    } catch (error) {
      console.error("Error in getQuizTest:", error);
    }
  };

  const getBookData = (needfilter) => {
    if (currentUser.isTeacher) {
      db.collection('zSystemStore')
        .where('createdBy', '==', currentUser._uniqueID)
        .where('type', '==', 'book')
        .get()
        .then((querySnapshot) => {
          let book = querySnapshot.docs.map((doc) => doc.data());
          setBookData(book);
        });
    }else{
      db.collection('zSystemStore')
        .where('type', '==', 'book')
        .get()
        .then((querySnapshot) => {
          let book = querySnapshot.docs.map((doc) => doc.data());
          setBookData(book);
        });
      }
  };

  const getQuizData = (needfilter) => {
    db.collection('zSystemStore')
      .where('type', '==', 'quiz')
      .get()
      .then((querySnapshot) => {
        let quiz = querySnapshot.docs.map((doc) => doc.data());
        setProgressVisible(false);
        setQuizData(quiz);
      });
  };

  const getBooks = (material) => {
    if (currentUser.isTeacher){

      db.collection('zSystemStore')
        .where('createdBy', '==', currentUser._uniqueID)
        .where('type', '==', 'book')
        .get()
        .then((querySnapshot) => {
          let data = querySnapshot.docs.map((doc) => doc.data());
          let bookArray = {};
          material.book.forEach((item, i) => {
            bookArray[item] = true;
          });
          setAddedBooks(bookArray);
          setSelectedBook(bookArray);
          setBookData(data);
        })
        .catch((err) => {
          notify(err.toString(), true);
          console.log('err', err);
        });
    }else{

      db.collection('zSystemStore')
        // .where('createdBy', '==', selectedTeacher.id)
        .where('type', '==', 'book')
        .get()
        .then((querySnapshot) => {

          let data = querySnapshot.docs.map((doc) => doc.data());
          let bookArray = {};
          material.book.forEach((item, i) => {
            bookArray[item] = true;
          });
          setAddedBooks(bookArray);
          setSelectedBook(bookArray);

          setBookData(data);
        })
        .catch((err) => {
          notify(err.toString(), true);
          console.log('err', err);
        });
    }

  };

  const getQuiz = (material) => {
    db.collection('zSystemStore')
      .where('type', '==', 'quiz')
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => doc.data());
        let quizArray = {};

        material.quiz.forEach((item, i) => {
          quizArray[item] = true;
        });
        setAddedQuizes(quizArray);
        setProgressVisible(false);
        setSelectedQuiz(quizArray);
        setQuizData(data);
      })
      .catch((err) => {
        notify(err.toString(), true);
        console.log('err', err);
      });
  };

  const findBatchData = () => {
    let batchDataFilter = batchData.find((item) => item.itemID === currentBatchId);
    setCurrentBatch({ batchId: batchDataFilter.itemID, batchName: batchDataFilter.batchName, status :0});
  }

  useEffect(() => {
    findBatchData();
    setProgressValue(99);
    db.collection('studyMaterial')
      .doc(currentBatchId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          getBooks(doc.data());
          getQuizTest()
          // getQuiz(doc.data());
          return;
        }

        getBookData();
        // getQuizData();
        getQuizTest()
      });
  }, []);

  const saveBatchForAssignedQuizTest = async (checked, quizId) => {
    try {

      // Await the query to ensure proper data fetching
      const querySnapshot = await db
        .collection('AssignedQuizTests')
        .where("QuizTestId", "==", quizId)
        .get();

      // Map through the fetched documents
      const [assignedQuizTestData] = querySnapshot.docs.map((doc) => doc.data());
      if(!assignedQuizTestData) {
        return;
      }

      if(checked){
        if (assignedQuizTestData.batchIds.includes(currentBatchId)){
        }else{
      await db.collection('AssignedQuizTests')
            .doc(quizId)
            .update({
              batchIds: [...assignedQuizTestData.batchIds, currentBatchId],
              batches: [...assignedQuizTestData.batches, currentBatch]
            })
          console.log("Batch does not exist");
        }
      }else{
        if (assignedQuizTestData.batchIds.includes(currentBatchId)){
          await db.collection('AssignedQuizTests')
            .doc(quizId)
            .update({
              batchIds: assignedQuizTestData.batchIds.filter((id) => id !== currentBatchId),
              batches: assignedQuizTestData.batches.filter((batch) => batch.batchId !== currentBatchId)
            })
          console.log("Batch  exists");
        }else{
          console.log("Batch does not exist");
        }
      }
    } catch (err) {
      console.error("Error fetching assigned quiz test data:", err);
    }
  };

  const onSubmit = (data) => {
    let deletedBooks = bookAddedCount
      ?.filter((item) => item.value === false)
      .map((item) => item.id);
    let deletedQuizes = quizAddedCount
      ?.filter((item) => item.value === false)
      .map((item) => item.id);
    let finalSelectedQuiz =
      selectedQuizCount.lenght !== 0
        ? selectedQuizCount.map((item) => item.id)
        : [];
    let finalSelectedBook =
      selectedBookCount.lenght !== 0
        ? selectedBookCount.map((item) => item.id)
        : [];
    db.collection('studyMaterial')
      .doc(currentBatchId)
      .set(
        {
          book: finalSelectedBook,
          quiz: finalSelectedQuiz,
          deletedBooks: deletedBooks,
          deletedQuizes: deletedQuizes,
          type: 'batch',
        },
        { merge: true }
      )
      .then((res) => {
        handleClose();
        notifi('Study material added Successfully', false);
      });

    return;
  };

  return (
    <div
      style={{
        backgroundColor: '#1f1e2e',
        height: '100%',
        overflowY: 'scroll',
      }}
    >
      {progressVisible && (
        <Progress color='info' value={progressValue} style={{ height: 4 }} />
      )}

      <div className='react-notification-alert-container'>
        <NotificationAlert ref={notification} />
      </div>

      <div style={{ padding: '5px 20px' }}>
        <Row style={{ justifyContent: 'flex-end' }}>
          <IconButton
            edge='start'
            style={{ color: 'white' }}
            onClick={handleClose}
            aria-label='close'
          >
            <CloseIcon />
          </IconButton>
        </Row>
        <Row>
          <Col md='12' style={{ marginBottom: '100px' }}>
            <Card style={{ margin: 0 }}>
              <CardHeader>
                <h5 className='title'>Add Study Material</h5>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col sm={6} style={{ borderRight: '1px solid #3d4356' }}>
                    <h5 className='title' style={{ paddingLeft: '20px' }}>
                      Books
                    </h5>
                    <br></br>
{bookData.length>0 ?
                    <Table className='tablesorter'>
                      <thead className='text-primary'>
                        <tr>
                          <th> </th>
                          <th>Book Title</th>
                          <th>Author</th>
                          <th>Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bookData.map((item) => {
                          return (
                            <tr key={item.itemID}>
                              <td
                                style={{ display: 'flex', paddingLeft: '20px' }}
                              >
                                <Input
                                  type='checkbox'
                                  checked={selectedBook[item.itemID]}
                                  onChange={(e) => {
                                    if (addedBooks[item.itemID] !== undefined) {
                                      setAddedBooks((prev) => ({
                                        ...prev,
                                        [item.itemID]: !prev[item.itemID],
                                      }));
                                    }
                                    setSelectedBook((prev) => ({
                                      ...prev,
                                      [item.itemID]: !prev[item.itemID],
                                    }));
                                  }}
                                />
                              </td>
                              <td>{item.title}</td>
                              <td>{item.author}</td>
                              <td style={{ minWidth: '70px' }}>
                                ₹ {item.price}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      </Table> : <div
                        style={{
                          textAlign: 'center',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          padding: '20px',
                          border: '1px solid #ddd',
                          borderRadius: '8px',
                          marginTop: '20px',
                          color:'white'
                        }}
                      >
                        Books are Not Available
                      </div>
                    }
                  </Col>
                  <Col sm={6} style={{ borderRight: '1px solid #3d4356' }}>
                    <h5 className='title' style={{ paddingLeft: '20px' }}>
                      Mock
                    </h5>
                    <br></br>
                    <Table className='tablesorter'>
                      <thead className='text-primary'>
                        <tr>
                          <th> </th>
                          <th>Mock Title</th>
                          <th>No of Questions</th>
                          <th>Price</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        
                        {quizData.map((item) => {
                          return (
                            <tr key={item.itemID}>
                              <td
                                style={{ display: 'flex', paddingLeft: '20px' }}
                              >
                                <Input
                                  type='checkbox'
                                  checked={selectedQuizTestArr.includes(item.id)}
                                  onChange={(e) => {
                                    saveBatchForAssignedQuizTest(e.target.checked, item.id);
                                    if(e.target.checked){ 
                                      setSelectedQuizTestArr((prev) => [...prev, item.id]);
                                    }else{
                                      setSelectedQuizTestArr((prev) => prev.filter((id) => id !== item.id));
                                    }
                                  }}
                                />
                              </td>
                              <td>{item.name}</td>
                              <td>{item.quizQuestions.length}</td>
                              <td style={{ minWidth: '70px' }}>
                                ₹ {item.price}
                              </td>
                              <td>
                                {selectedQuizTestArr.includes(item.id)?'Assigned':''}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
                <br></br>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/* {selectedBookCount.length !== 0 ||
        selectedQuizCount.length !== 0 || currentBatchId ? ( */}
        <Row
          style={{
            position: 'fixed',
            bottom: '0',
            minHeight: '60px',
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
            left: '-10',
            backgroundColor: '#272a3d',
          }}
        >
          <Form
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row style={{ width: '100%', alignItems: 'center' }}>
              <Button color='info' type='submit'>
                Submit
              </Button>
            </Row>
          </Form>
        </Row>
        {/* ) : (
          <div></div>
        )} */}
      </div>
    </div>
  );
}
export default AddMaterial;
